import axios from 'axios';
import { axiosToast } from '../axios';

axios.interceptors.response.use(
  (response) => {
    const { data } = response;
    const useToast = window.store.state.global.useToastInterceptor;
    if (useToast) {
      axiosToast(data);
    }

    return response;
  },

  (error) => {
    const { data } = error.response;

    axiosToast(data);

    return Promise.reject(error);
  }
);
